enum MultiMetricGraphIndex {
  First = 'first',
  Second = 'second',
  Third = 'third',
}

export default MultiMetricGraphIndex;
